import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";

export const checkLoginExistenceRoute = (login: string): string =>
  buildUrl({
    url: `${baseUrl}/gateway/v1/users/check`,
    searchParams: { login },
  });
